import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';
import telegram from "../assets/telegramIcon.svg";
import server from "../assets/serverIcon.svg";
import support from "../assets/supportIcon.svg";
import etycloud from '../assets/etycloud.svg';

const Footer = () => (
    <footer className="footer">
        <div className="footer__top">
            <div className="footer__actions">
                <a className="ui-btn ui-btn--secondary" href="https://t.me/animixlib">
                    <img src={telegram} alt="" /> Мы в Telegram
                </a>
                <a className="ui-btn ui-btn--secondary" href="https://t.me/animixlib_bot">
                    <img src={support} alt="" /> Поддержка
                </a>
                <a className="ui-btn ui-btn--secondary" href="https://animixstatus.whitewhale.help">
                    <img src={server} alt="" /> Статус серверов
                </a>
            </div>
            <nav className="footer__links" aria-label="Информация">
                <Link to="/contact">Контакты</Link>
                <Link to="/about">О нас</Link>
                <Link to="/community">Правила сообщества</Link>
                <Link to="/legal">Правообладателям</Link>
                <Link to="/privacy">Политика конфиденциальности</Link>
            </nav>
        </div>

        <div className="footer__bottom">
            <p>animix 2024–2026. Применяются рекомендательные технологии</p>
            <a className="footer__sponsor" href="https://cloud.ety.one">
                <img src={etycloud} alt="ety cloud" />
            </a>
        </div>
    </footer>
);

export default Footer;
